import React from 'react'
import { useState } from 'react';
import {Link} from 'react-router-dom'
import MenuIcon from '@mui/icons-material/Menu';
import IconButton from '@mui/material/IconButton';
import '../styles/NavigationBar.css';

import Drawer from 'react-modern-drawer'
import 'react-modern-drawer/dist/index.css'

function BurgerMenu() {
    const [isOpen, setIsOpen] = useState(false)
    const [buttonVisibility, setButtonVisibility] = useState('visible')

    const toggleDrawer = () => {
        setIsOpen((prevState) => !prevState)
        setButtonVisibility((prevState) => prevState === 'visible' ? 'hidden' : 'visible')
    }
  return (
    <div className='navigation-drawer-container'>
        <IconButton onClick={toggleDrawer}><MenuIcon fontSize='large' style={{color: 'white', visibility: buttonVisibility}}/></IconButton>
        <Drawer
            open={isOpen}
            onClose={toggleDrawer}
            direction='right'
            className='navigation-drawer'
            style={{backgroundColor: 'rgba(255, 255, 255, 0.8)'}}
        >
            <Link to='/'>
            <button className='NavButton'>Aktuelles</button>
            </Link>
            <Link to='/Anmeldung'>
            <button className='NavButton'>Anmeldung</button>
            </Link>
            <Link to='/About'>
            <button className='NavButton'>Über uns</button>
            </Link>
            <Link to='/Location'>
            <button className='NavButton'>Location</button>
            </Link>
            <Link to='/Bilder'>
            <button className='NavButton'>Bilder</button>
            </Link>
        </Drawer>
    </div>
    // <Menu className='BurgerMenu' pageWrapId={ "page-wrap" } outerContainerId={ "outer-container" } right>
    //     <Link to='/'>
    //     <button className='NavButton'>Aktuelles</button>
    //     </Link>
    //     <Link to='/Anmeldung'>
    //     <button className='NavButton'>Anmeldung</button>
    //     </Link>
    //     <Link to='/About'>
    //     <button className='NavButton'>Über uns</button>
    //     </Link>
    //     <Link to='/Location'>
    //     <button className='NavButton'>Location</button>
    //     </Link>
    //     <Link to='/Bilder'>
    //     <button className='NavButton'>Bilder</button>
    //     </Link>


    //     {/* <Link to='/Admin/Bilder'>
    //     <button className='NavButton'>Admin Bilder</button>
    //     </Link> */}

    // </Menu>
  )
}

export default BurgerMenu